import { NextRequest, NextResponse } from "next/server";
import { getCityByGeo } from "api/location";

import { COOKIES } from "constants/enum";

import { getCookieExpires } from "./getCookieExpires";

const ENABLE_GEO_BY_GEO = false;

export const getCityByCoords = async (
    req: NextRequest,
    resp: NextResponse,
    version: string,
    latitude: string,
    longitude: string,
    ignoreCookies = false
) => {
    if (!ignoreCookies) {
        const cityIDFromCookies = req.cookies.get(COOKIES.GEO_CITY_ID);
        const cityNameFromCookies = req.cookies.get(COOKIES.GEO_CITY);

        if (cityNameFromCookies && cityIDFromCookies) {
            return { id: cityIDFromCookies, name: cityNameFromCookies };
        }
    }
    try {
        if (!ENABLE_GEO_BY_GEO) {
            return null;
        }

        const cityData = await getCityByGeo(version, latitude, longitude);
        if (!cityData) return null;

        const { id, title, label } = cityData;
        const expires = getCookieExpires();
        const cityName = label || title;

        resp.cookies.set(COOKIES.GEO_CITY_ID, id.toString(), { expires });
        resp.cookies.set(COOKIES.GEO_CITY, cityName, { expires });
        // Save country where we are searching cities in
        resp.cookies.set(COOKIES.GEO_SEARCH_COUNTRY, version, { expires });
        return { id, name: cityName };
    } catch {
        return null;
    }
};
